export default "/_next/static/chunks/fonts/Outfit Light-27737e30f9f52f95ba31d01c55a4f0f8.ttf";